module.exports = __webpack_public_path__ + "img/logoBID22-12EEW_76700c2631723221596b2bba224f1984.longcache.png";